import CardTitle from '@/views/components/Cards/CardTitle';
import MyPieChart from '@/views/components/Charts/MyPieChart';
import Paper from '@/views/components/Paper/Paper';
import { Col, Row } from 'antd';
import StackedBar from '../../common/StackedBar';
import { CLAIMS_BY_REASONS_SAMPLE_DATA, CLAIMS_BY_STATUS_SAMPLE_DATA } from './constants';

const OCClaimDashboard = () => {
  return (
    <div className="h-100 d-flex flex-direction-column p-16 justify-content-between">
      <Row gutter={15} className="h-49">
        <Col md={24} lg={12} className="h-100">
          <Paper className="h-100 d-flex flex-direction-column overflow-visible" border>
            <div>
              <CardTitle title="Top Transportation Providers With Recovery Amount" />
            </div>
            <div className="p-10 flex-1 d-flex flex-direction-column justify-content-center">
              <StackedBar />
            </div>
          </Paper>
        </Col>
        <Col md={24} lg={12} className="h-100">
          <Paper className="h-100 d-flex flex-direction-column overflow-visible" border>
            <div>
              <CardTitle title="Top Transportation Providers With Overcharge Amount" />
            </div>
            <div className="p-10 flex-1 d-flex flex-direction-column justify-content-center">
              <StackedBar />
            </div>
          </Paper>
        </Col>
      </Row>
      <Row gutter={15} className="h-49">
        <Col md={24} lg={12} className="h-100">
          <Paper className="h-100 d-flex flex-direction-column overflow-visible" border>
            <div>
              <CardTitle title="Claims By Status" />
            </div>
            <div className="p-10 flex-1 d-flex flex-direction-column justify-content-center">
              <MyPieChart data={CLAIMS_BY_STATUS_SAMPLE_DATA} palette="darkViolet" outerRadius={80} />
            </div>
          </Paper>
        </Col>

        <Col md={24} lg={12} className="h-100">
          <Paper className="h-100 d-flex flex-direction-column" border>
            <div>
              <CardTitle title="Claims By Reasons" />
            </div>
            <div className="p-10 flex-1 d-flex flex-direction-column justify-content-center">
              <MyPieChart data={CLAIMS_BY_REASONS_SAMPLE_DATA} palette="pastel" outerRadius="75%" withLegend />
            </div>
          </Paper>
        </Col>
      </Row>
    </div>
  );
};

export default OCClaimDashboard;
